import React from 'react';
import { Typography, Box } from '@mui/material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';
import { 
  FlatRateEditor, 
  PercentBilledEditor, 
  MaxRateEditor 
} from '../../fieldEditors/contractEditors';

const UnspecifiedSection: React.FC = () => {
  return (
    <SectionPaper>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
        Unspecified Rates Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure rates for unspecified procedures and services.
      </Typography>
      
      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: { 
          xs: '1fr', 
          sm: '1fr 1fr', 
          md: '1fr 1fr 1fr' 
        }, 
        gap: 3 
      }}>
        <FlatRateEditor />
        <PercentBilledEditor />
        <MaxRateEditor />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Typography variant="caption" color="text.secondary">
          All fields are optional. Leave blank if not applicable to this contract.
        </Typography>
      </Box>
    </SectionPaper>
  );
};

export default UnspecifiedSection;